'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import personActions from 'actions/PersonActionCreators';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListSection from 'components/base/list-components/ListSection';
import ListItem from 'components/base/list-components/ListItem';
import ListItemCellRight from 'components/base/list-components/ListItemCellRight';

import utils from 'services/utils';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    id: PropTypes.string,
};

class LeaveBalanceWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var _this = this;
        setTimeout(function () {
            personActions.getSinglePersonLeaveBalances(_this.props.person.Id, moment().format(appConstants.dates.formats.SERVER_POST_FORMAT));
        }, 0);
    }

    inDays(hoursPerDay, hours) {
      
        if (!hoursPerDay) {
            return 0;
        } 

        return hours / hoursPerDay;
    }

    render() {

        var initialLoading = false;
        var link = "";
        var leaveBalanceListContent = [];
        var error = null;
        var heading = "Leave Balances";
        if (this.props.person.leaveBalances) {
            initialLoading = this.props.person.leaveBalances.loading;
        }
        
        if (this.props.person.leaveBalances && this.props.person.leaveBalances.loading) {
            initialLoading = true;
        } else {
            if (this.props.person && this.props.person.Id && this.props.person.leaveBalances && this.props.person.leaveBalances.balances) {

                link = "/members/" + this.props.person.Id + "/leave/";
                
                if (this.props.person.leaveBalances.balances.length > 0) {
                    leaveBalanceListContent =  this.props.person.leaveBalances.balances.map(function (leaveBalance, index) {

                        var valueContent = <ListItemCellRight value={utils.formatNumber(this.inDays(leaveBalance.HoursPerDay, leaveBalance.TotalHours))} unit="days" altValue={utils.formatNumber(leaveBalance.TotalHours)} altUnit="hours" />;
                        
                        return (
                            <ListItem 
                                key={index}
                                iconName={leaveBalance.IconName} 
                                colorName={leaveBalance.ColorName} 
                                heading={leaveBalance.Label || "Unknown"} 
                                subheading="Entitlement" 
                                content={valueContent} 
                                rightAlignContent
                            />
                        );
                    }.bind(this));
                } else {
                    leaveBalanceListContent = <ListItem key="0" content="You have no leave balances" />;
                }
                
            } else if (this.props.person && this.props.person.Id && this.props.person.leaveBalances && this.props.person.leaveBalances.error) {
                error = heading;
            }
        }

        return (
            
            <PageSection id="leave-balances-widget">
                <List icon="icon-leave-balances" id={this.props.id} heading={heading} link={link} multiSelect loading={initialLoading} error={error}>
                    <ListSection  maxItems={3} moreLink={link}>
                        {leaveBalanceListContent}
                    </ListSection>
                </List>
            </PageSection>
            
        );
    }
}

LeaveBalanceWidget.propTypes = propTypes;

export default LeaveBalanceWidget; 
